export function validateEmail(value) {
  return /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(value);
}

export const isTrue = v => v === true || v === 'true';

export default {
  validateEmail,
};
